const CDN_URL = process.env.REACT_APP_CDN_URL;

const print = {
  title: "Want us to print for you?",
  description:
    "We offer premium printing services tailored to your needs. Choose from our professional print options below.",
  title2: "Want us to print for you?",
  services: [
    {
      title: "Basic Print",
      price: "Starting at $22/sqft",
      description: "Ideal for surfaces up to 15 ft high without obstacles.",
      features: [
        "Free Consultation",
        "CMYK Included",
        "Professional Operator",
        "100% Satisfaction Guaranteed",
      ],
    },
    {
      title: "White Underlay",
      price: "Starting at $25/sqft",
      description: "Ensures vibrant colors on darker surfaces.",
      features: [
        "Free Consultation",
        "CMYK + White Underlay",
        "Professional Operator",
        "100% Satisfaction Guaranteed",
      ],
    },
    {
      title: "Graphic Design",
      price: "Starting at $99/hr",
      description: "Custom designs tailored to your vision.",
      features: [
        "Dedicated Graphic Designer",
        "Unlimited Revisions",
        "Art Optimized for Wall Printing",
      ],
    },
  ],

  categories: [
    {
      title: "Drywall",
      description:
        "Drywall surfaces are by far our most common prints. Printing on your drywall inside creates the vibe or culture you have been looking for. With our UV curing ink, it is instantly dry to the touch and looks amazing.",
      images: [
        {
          src: `${CDN_URL}/gallery/plaster-14.jpg`,
          alt: "Drywall 1",
          size: "small",
        },
        {
          src: `${CDN_URL}/gallery/plaster-15.jpg`,
          alt: "Drywall 2",
          size: "medium",
        },
        {
          src: `${CDN_URL}/gallery/plaster-16.jpg`,
          alt: "Drywall 3",
          size: "small",
        },
        {
          src: `${CDN_URL}/gallery/plaster-17.jpg`,
          alt: "Drywall 4",
          size: "small",
        },
        {
          src: `${CDN_URL}/gallery/plaster-18.jpg`,
          alt: "Drywall 5",
          size: "small",
        },
        {
          src: `${CDN_URL}/gallery/plaster-20.jpg`,
          alt: "Drywall 6",
          size: "small",
        },
        {
          src: `${CDN_URL}/gallery/plaster-22.jpg`,
          alt: "Drywall 7",
          size: "small",
        },
        {
          src: `${CDN_URL}/gallery/plaster-23.jpg`,
          alt: "Drywall 8",
          size: "small",
        },
        {
          src: `${CDN_URL}/gallery/plaster-25.jpg`,
          alt: "Drywall 9",
          size: "small",
        },
        {
          src: `${CDN_URL}/gallery/plaster-26.jpg`,
          alt: "Drywall 10",
          size: "small",
        },
        {
          src: `${CDN_URL}/gallery/plaster-29.jpg`,
          alt: "Drywall 11",
          size: "small",
        },
        {
          src: `${CDN_URL}/gallery/plaster-33.jpg`,
          alt: "Drywall 12",
          size: "small",
        },
        {
          src: `${CDN_URL}/gallery/plaster-34.jpg`,
          alt: "Drywall 13",
          size: "small",
        },
      ],
    },
    {
      title: "Concrete",
      description:
        "Even porous and uneven surfaces such as brick are not a challenge that we can’t handle. It can be interior or exterior as well—either way, it won’t make a difference. Showcase your art on virtually any surface you can think of.",
      images: [
        {
          src: `${CDN_URL}/gallery/concrete-1.jpg`,
          alt: "Brick 1",
          size: "small",
        },
        {
          src: `${CDN_URL}/gallery/concrete-2.jpg`,
          alt: "Brick 2",
          size: "small",
        },
        {
          src: `${CDN_URL}/gallery/concrete-3.jpg`,
          alt: "Brick 3",
          size: "small",
        },
      ],
    },
    {
      title: "Glass",
      description:
        "One of our coolest applications for printing is glass. It looks amazing and is very simple to remove—just pull out a razor blade and scratch it off.",
      images: [
        {
          src: `${CDN_URL}/gallery/glass-2.jpg`,
          alt: "Glass 1",
          size: "small",
        },
        {
          src: `${CDN_URL}/gallery/glass-3.jpg`,
          alt: "Glass 2",
          size: "small",
        },
        {
          src: `${CDN_URL}/gallery/glass-4.jpg`,
          alt: "Glass 3",
          size: "small",
        },
      ],
    },
    {
      title: "Wood",
      description:
        "Printing on wood surfaces adds a rustic and artistic touch. Whether smooth or textured, our prints retain excellent detail.",
      images: [
        { src: `${CDN_URL}/gallery/wood-3.jpg`, alt: "Wood 1", size: "small" },
        { src: `${CDN_URL}/gallery/wood-4.jpg`, alt: "Wood 2", size: "small" },
        {
          src: `${CDN_URL}/gallery/DSC00052.JPG`,
          alt: "Wood 2",
          size: "small",
        },
        {
          src: `${CDN_URL}/gallery/DSC02425.jpg`,
          alt: "Wood 2",
          size: "small",
        },
      ],
    },
  ],

  whatElse: {
    title: "What Else Can We Print On?",
    description:
      "From unique surfaces like surfboards and window blinds to unconventional materials, we push the boundaries of vertical printing.",
    video: "https://www.youtube.com/embed/jaxUEVq2NBY",
  },
};

export default print;
